import React from 'react';

import { getBearingEnvelopeUserVisibleTerm } from '../../../library/utilities/bearingEnvelopeUserTerm';
import { getDistanceFormatterSelector } from '../../../store/selectors/getDistanceFormatterSelector';
import { getBearingEnvelopeHeight } from '../../../store/selectors/layoutDataSelectors';
import { useAppSelector } from '../../hooks';
import { TooltipContent, TooltipText } from './common';

export function BearingEnvelopeTooltip(props: { guid: string }) {
  const bearingEnvelope = useAppSelector((state) => state.layout.bearingEnvelopes[props.guid]);
  const formatDistance = useAppSelector(getDistanceFormatterSelector);

  if (bearingEnvelope == null) {
    console.warn('unable to find bearing envelope for tooltip.');
    return null;
  }

  const height = getBearingEnvelopeHeight(bearingEnvelope);
  const userVisibleTerm = getBearingEnvelopeUserVisibleTerm(bearingEnvelope.bearingType);
  const { bearingType, thickness, numberOfPlies } = bearingEnvelope;

  const formattedThickness =
    bearingType !== 'Beam' || numberOfPlies < 2
      ? formatDistance(thickness)
      : `${formatDistance(thickness * numberOfPlies)} (${numberOfPlies} plies @ ${formatDistance(thickness)})`;

  return (
    <TooltipContent>
      <TooltipText>
        {userVisibleTerm} {bearingEnvelope.name}
      </TooltipText>

      {bearingEnvelope.bearingType === 'Beam' && height != null && (
        <TooltipText>
          {bearingEnvelope.beamOrientation} Beam, {formatDistance(height)} Tall
        </TooltipText>
      )}

      <TooltipText>Thickness: {formattedThickness}</TooltipText>

      <TooltipText>Top Elevation: {formatDistance(bearingEnvelope.top)}</TooltipText>
    </TooltipContent>
  );
}
